import { Radio, Stack, Text } from '@mantine/core';
import { VestingMode } from '@dealstack/shared/lib/generated';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useVestingTermsContext } from '@dealstack/frontend/shared/components/VestingTerms/VestingTermsContext.tsx';
import { VestingCard } from '@dealstack/frontend/shared/components/VestingCard/VestingCard.tsx';

export const VestingModeRadio = () => {
	const tCommonUi = useTranslationCommonUi();
	const { currentVestingTerm, onUpdateVestingTerm } = useVestingTermsContext();

	return (
		<VestingCard
			title={tCommonUi('vesting_terms.vesting_mode.label')}
			titleSize="md"
			titleWeight={600}
			titleColor="dark.8"
		>
			<Radio.Group
				value={currentVestingTerm.vestingMode}
				onChange={(value) =>
					onUpdateVestingTerm(currentVestingTerm.id, {
						vestingMode: value as VestingMode,
					})
				}
				mt="0.5rem"
			>
				<Stack gap="0.5rem">
					<Radio
						value={VestingMode.VALUE}
						label={tCommonUi('vesting_terms.vesting_mode.value')}
						description={
							<Text size="xs" c="dimmed">
								{tCommonUi('vesting_terms.vesting_mode.value_description')}
							</Text>
						}
					/>
					<Radio
						value={VestingMode.PHYSICAL}
						label={tCommonUi('vesting_terms.vesting_mode.physical')}
						description={
							<Text size="xs" c="dimmed">
								{tCommonUi('vesting_terms.vesting_mode.physical_description')}
							</Text>
						}
					/>
				</Stack>
			</Radio.Group>
		</VestingCard>
	);
};
